export default "__VITE_ASSET__D6Ijw0Gb__"